import { theme } from '@prophecy/theme';
import { Button } from '@prophecy/ui-v3/Button';
import { Stack } from '@prophecy/ui-v3/Layout/Stack';
import { Text } from '@prophecy/ui-v3/Typography/Text';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface BillingCardProps {
  title: string;
  value?: ReactNode;
  additionalInfo?: ReactNode;
  buttonText?: string;
  onClick?: () => void;
}
export const BillingCard = ({ title, value, additionalInfo, buttonText, onClick }: BillingCardProps) => {
  return (
    <BillingCardContainer direction='vertical' gap={theme.spaces.x12} align='space-between'>
      <Stack gap={theme.spaces.x4}>
        <Text level='xs' weight={theme.fontWeight.medium} tone={theme.colors.gray700}>
          {title}
        </Text>
        {value && (
          <Text level='xl' weight={theme.fontWeight.semiBold} tone={theme.colors.gray700}>
            {value}
          </Text>
        )}
      </Stack>
      <Stack direction='vertical'>
        {additionalInfo && (
          <Text level='xs' tone={theme.colors.gray500}>
            {additionalInfo}
          </Text>
        )}

        {buttonText && (
          <BillingActionButton
            variant='link'
            size='xs'
            data-test-id='billing-overview-plan-manage-button'
            onClick={onClick}>
            {buttonText}
          </BillingActionButton>
        )}
      </Stack>
    </BillingCardContainer>
  );
};

const BillingCardContainer = styled(Stack)`
  padding: ${theme.spaces.x16};
  flex: 1;
  border: 1px solid ${theme.colors.gray200};
  border-radius: ${theme.spaces.x8};
  background-color: ${theme.colors.white};
`;

const BillingActionButton = styled(Button)`
  justify-content: flex-start;
` as unknown as typeof Button;
